// auto-generated by Typewriter template _models.tst from PortCall.Models\DomainSettings\VesselServiceSettings.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { VesselServiceActive } from 'server/enums/VesselServiceActive';

// VesselServiceSettingsData is the class that VesselServiceSettings serializes to/from
export interface VesselServiceSettingsData {
	
	
    LloydServiceActive : VesselServiceActive;
    LloydsRefreshThresholdDays : number;
    MarineTrafficRefreshThresholdDays : number;
    MarineTrafficServiceActive : VesselServiceActive;
    PSixRefreshThresholdDays : number;
    PSixServiceActive : VesselServiceActive;
}

// VesselServiceSettingsOptions is the class which may be passed to the VesselServiceSettings constructor to define optional initial data values
export interface VesselServiceSettingsOptions {
	
	
    LloydServiceActive? : VesselServiceActive;
    LloydsRefreshThresholdDays? : number;
    MarineTrafficRefreshThresholdDays? : number;
    MarineTrafficServiceActive? : VesselServiceActive;
    PSixRefreshThresholdDays? : number;
    PSixServiceActive? : VesselServiceActive;
}

export class VesselServiceSettings {
	
	
    public LloydServiceActive : DataSignal<VesselServiceActive>;
    public LloydsRefreshThresholdDays : DataSignal<number>;
    public MarineTrafficRefreshThresholdDays : DataSignal<number>;
    public MarineTrafficServiceActive : DataSignal<VesselServiceActive>;
    public PSixRefreshThresholdDays : DataSignal<number>;
    public PSixServiceActive : DataSignal<VesselServiceActive>;

    constructor();
    constructor(data : VesselServiceSettingsOptions);
    constructor(data: VesselServiceSettingsOptions | null = null) {
	    
	    
        this.LloydServiceActive = jsonableObservable(S.value<VesselServiceActive>(data && data.LloydServiceActive !== undefined ? data.LloydServiceActive : 0));
        this.LloydsRefreshThresholdDays = jsonableObservable(S.value<number>(data && data.LloydsRefreshThresholdDays !== undefined ? data.LloydsRefreshThresholdDays : 0));
        this.MarineTrafficRefreshThresholdDays = jsonableObservable(S.value<number>(data && data.MarineTrafficRefreshThresholdDays !== undefined ? data.MarineTrafficRefreshThresholdDays : 0));
        this.MarineTrafficServiceActive = jsonableObservable(S.value<VesselServiceActive>(data && data.MarineTrafficServiceActive !== undefined ? data.MarineTrafficServiceActive : 0));
        this.PSixRefreshThresholdDays = jsonableObservable(S.value<number>(data && data.PSixRefreshThresholdDays !== undefined ? data.PSixRefreshThresholdDays : 0));
        this.PSixServiceActive = jsonableObservable(S.value<VesselServiceActive>(data && data.PSixServiceActive !== undefined ? data.PSixServiceActive : 0));
    }

    static key(obj : VesselServiceSettings) {
        return ;
    }
    
    static dataKey(obj : VesselServiceSettingsOptions) {
        return ;
    }

    static update(obj : VesselServiceSettings, data : VesselServiceSettingsOptions) {
        S.freeze(() => {
	        
	        
            if (data.LloydServiceActive !== undefined) obj.LloydServiceActive(data.LloydServiceActive);
            if (data.LloydsRefreshThresholdDays !== undefined) obj.LloydsRefreshThresholdDays(data.LloydsRefreshThresholdDays);
            if (data.MarineTrafficRefreshThresholdDays !== undefined) obj.MarineTrafficRefreshThresholdDays(data.MarineTrafficRefreshThresholdDays);
            if (data.MarineTrafficServiceActive !== undefined) obj.MarineTrafficServiceActive(data.MarineTrafficServiceActive);
            if (data.PSixRefreshThresholdDays !== undefined) obj.PSixRefreshThresholdDays(data.PSixRefreshThresholdDays);
            if (data.PSixServiceActive !== undefined) obj.PSixServiceActive(data.PSixServiceActive);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/VesselServiceSettings.ts